import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, Cascader, Select } from "antd";
import { UserContext } from "../../../context/UserContext";
import { DROPDOWNS } from "../../../consts";
import { getAllowedRoles } from "../../../utils/api";

const { Option } = Select;

const CreateModalContent = ({ data, setOpen, createCallback, siteData }) => {
  const [form] = Form.useForm();
  const { userData } = useContext(UserContext);
  const [allowedRoles, setAllowedRoles] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]); // initially empty as requested

  const fetchAllowedRoles = async () => {
    const allowedRolesRes = await getAllowedRoles(siteData[0].organization_id);
    const visibleRoles = (allowedRolesRes.data.data || []).filter(
      (role) => role.is_visible_for_assignment,
    );
    setAllowedRoles(visibleRoles);
  };

  useEffect(() => {
    if (siteData && siteData.length > 0) {
      fetchAllowedRoles();
    }
  }, [siteData]);

  const onFinish = (values) => {
    values.site_admin_ids =
      values.site_admin_ids?.map((site_admin) => site_admin[1]) || [];
    values.site_ids = values.site_ids?.map((site) => site[1]) || [];
    values.roles = selectedRoles;
    createCallback(values);
    setOpen(false);
    form.resetFields();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleRoleChange = (roleIds) => {
    setSelectedRoles(roleIds);
  };

  return (
    <div className="flex justify-center">
      <Form
        id="createUserForm"
        form={form}
        className="max-w-[80%]"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="first_name"
            label="First Name"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input placeholder="First Name" />
          </Form.Item>
          <Form.Item
            name="last_name"
            label="Last Name"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input placeholder="Last Name" />
          </Form.Item>
        </div>
        <Form.Item
          name="email"
          label="Email"
          rules={[{ required: true, message: "Required" }]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <div className="flex items-center justify-between">
          <Form.Item name="site_ids" label="Sites">
            <Cascader
              multiple
              className="min-w-[100px]"
              options={DROPDOWNS.GROWING_ENVIRONMENTS.map((env) => ({
                label: env.label,
                value: env.value,
                disableCheckbox: true,
                children: siteData
                  .filter((site) => site?.growing_environment === env.value)
                  .map((filteredSite) => ({
                    label: filteredSite.name,
                    value: filteredSite.id,
                  })),
              }))}
            />
          </Form.Item>
          <Form.Item name="site_admin_ids" label="Site Admin">
            <Cascader
              multiple
              className="min-w-[100px]"
              options={DROPDOWNS.GROWING_ENVIRONMENTS.map((env) => ({
                label: env.label,
                value: env.value,
                disableCheckbox: true,
                children: siteData
                  .filter((site) => site?.growing_environment === env.value)
                  .map((filteredSite) => ({
                    label: filteredSite.name,
                    value: filteredSite.id,
                  })),
              }))}
            />
          </Form.Item>
        </div>

        {/* Roles selection */}
        <Form.Item label="Roles">
          <Select
            mode="multiple"
            placeholder="Select roles"
            value={selectedRoles}
            onChange={handleRoleChange}
          >
            {allowedRoles.map((role) => (
              <Option key={role.id} value={role.id}>
                {role.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <div className="flex items-center justify-between">
          {userData?.is_superuser && (
            <Form.Item
              name="is_superuser"
              initialValue={false}
              valuePropName="checked"
              label="Superuser"
            >
              <Checkbox />
            </Form.Item>
          )}
          {(userData?.is_superuser || userData?.is_admin) && (
            <Form.Item
              name="is_admin"
              valuePropName="checked"
              initialValue={false}
              label="Admin"
            >
              <Checkbox />
            </Form.Item>
          )}
          <Form.Item
            name="is_active"
            valuePropName="checked"
            initialValue={false}
            label="Active"
          >
            <Checkbox />
          </Form.Item>
        </div>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateModalContent;
